import React, {
  FunctionComponent, useContext,
} from 'react';
import { Flex, Box } from 'rebass/styled-components';
import { ThemeProvider } from 'styled-components';
import { NextActionExecutionHistory } from '@liveperson/lpcontextschemalib';
import { NextActionSummaryCard } from '.';
import Loading from '../Loading';
import {
  Pagination, ResultsEmpty, ScrollBox, SkeletonLogs,
} from '..';
import { useAppState, useDebuggerState } from '../../hooks';
import { debuggerDarkTheme, debuggerLightTheme } from '../../theme';

const PolicyExecutionHistory: FunctionComponent<{}> = () => {
  const { state, dispatch } = useDebuggerState();
  const { history, isLoading } = state;
  const { themeMode } = useAppState();

  const handlePageChange = (pageNumber: number) => {
    dispatch({ pageNumber });
  };

  const handleRecordsPerPageChange = (noOfRecordsPerPage: number) => {
    dispatch({ noOfRecordsPerPage });
  };

  return isLoading ? (
    <SkeletonLogs />
  ) : (
    <Flex flexDirection="column" height="calc(100% - 160px)" sx={{ position: 'relative' }}>
      {history.totalDocs < 1 ? (
        <ResultsEmpty text="No results found. Try a different search criteria or time frame." />
      ) : (
        <Flex flexDirection="column" height="100%" sx={{ position: 'relative' }}>
          <ThemeProvider theme={themeMode === 'dark' ? debuggerDarkTheme : debuggerLightTheme}>
            <ScrollBox flex={1}>
              {history.docs?.map((it: NextActionExecutionHistory, idx) => (
                <NextActionSummaryCard
                  execution={it}
                  key={it.executionId}
                  isDrawerOpen={idx === 0}
                />
              ))}
            </ScrollBox>
          </ThemeProvider>
          <Box pb={1} pt={5} pr={2}>
            <Pagination
              pageCount={history.totalPages}
              recordsPerPage={history.limit}
              onChangePage={handlePageChange}
              currentPageNumber={history.page}
              onChangeRecordsPerPage={handleRecordsPerPageChange}
              hasNextPage={history.hasNextPage}
              hasPrevPage={history.hasPrevPage}
            />
          </Box>
        </Flex>
      )}
    </Flex>
  );
};

export default PolicyExecutionHistory;
